import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import isRecord from "~/helpers/isRecord";
import { EVENTS_BASE_PATH } from "~mobile/events/helpers/eventsTimeContinuation";
import { receiverChildEditorKey } from "~produce/production/helpers/continuationAdapter";

export const EVENTS_JOB_TARGET_KIND = "eventsJob";

export const EVENTS_JOB_SOURCE_KIND = "eventsJobView";

export const EVENTS_JOBS_RAIL_ID = "jobs";

export interface EventsJobSourceCheckpoint {
	jobId: string;
	jobNumber: string;
}

export const isEventsJobSourceCheckpoint = (value: unknown): value is EventsJobSourceCheckpoint =>
	isRecord(value) && typeof value.jobId === "string" && typeof value.jobNumber === "string";

const EVENTS_JOB_ROUTE_PATTERN = /^\/events\/jobs\/([^/?#]+)$/;

export const buildEventsJobTarget = (productionJobId: string): ContinuationTarget => ({
	targetId: productionJobId,
	targetKind: EVENTS_JOB_TARGET_KIND
});

export const eventsJobSourceEditorKey = ({ jobId }: EventsJobSourceCheckpoint): string =>
	receiverChildEditorKey(EVENTS_JOBS_RAIL_ID, buildEventsJobTarget(jobId));

export const matchEventsJobReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = EVENTS_JOB_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return buildEventsJobTarget(decodeURIComponent(match[1]));
	} catch {
		return null;
	}
};

const eventsJobReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${EVENTS_BASE_PATH}/jobs/${encodeURIComponent(targetId)}`,
	matchesRoute: matchEventsJobReceiverRoute
};

export default eventsJobReceiverIdentityAdapter;
